import { InitComponent } from "@/components/Reference"
import HashSuggestion from "@/components/Reference/Hash/HashSuggestion"
import HashSuggestionFiles from "@/components/Reference/Hash/HashSuggestionFiles"

import { ReferenceExtension } from "../Reference"

const createReferenceHashExtension = (name: string, pasteRules?: string) =>
  ReferenceExtension.extend({
    name
  }).configure({
    suggestion: HashSuggestion,
    pasteRules,
    component: InitComponent
  })

export const ReferenceHashProject = createReferenceHashExtension(
  "referenceHashProject",
  "#(P) - \\w+"
)

export const ReferenceHashMilestone = createReferenceHashExtension(
  "referenceHashMilestone",
  "#(M) - \\w+"
)

export const ReferenceHashEpic = createReferenceHashExtension("referenceHashEpic", "#(E) - \\w+")

export const ReferenceHashIdea = createReferenceHashExtension("referenceHashIdea", "#(I) - \\d+")

export const ReferenceHashTeam = createReferenceHashExtension("referenceHashTeam", "#(T) - \\w+")

export const ReferenceHashSprint = createReferenceHashExtension(
  "referenceHashSprint",
  "#(S) - \\w+"
)

export const ReferenceHashItem = createReferenceHashExtension("referenceHashItem", "#[0-9]+ ")

export const ReferenceHashTask = createReferenceHashExtension(
  "referenceHashTask",
  "#[0-9]+\\.[0-9]+"
)

export const ReferenceHashTip = createReferenceHashExtension("referenceHashTip")

export const ReferenceHashFile = ReferenceExtension.extend({
  name: "referenceHashFile"
}).configure({
  suggestion: HashSuggestionFiles,
  pasteRules: "#(F)",
  component: InitComponent
})

export const ReferenceHashFileLink = ReferenceExtension.extend({
  name: "referenceHashFileLink"
}).configure({
  suggestion: HashSuggestionFiles,
  pasteRules: "#(F)",
  component: InitComponent
})
